import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { SplashScreenComponent } from "./splash-screen-component/splash-screen.component";

@NgModule({
	imports: [CommonModule],
	exports: [SplashScreenComponent],
	declarations: [SplashScreenComponent],
})
export class SplashScreenModule {}
